import React from "react";

const whyChoose = [
  {
    title: "Expert-Driven Strategies",
    text: "Backed by in-depth research and financial expertise.",
  },
  {
    title: "Personalized Solutions",
    text: "Tailored investment plans based on your financial goals.",
  },
  {
    title: "Transparent & Trustworthy",
    text: "Committed to integrity and client-first solutions.",
  },
];

const WhyChose = ({ data }) => {
  return (
    <div class="col-11 m-auto mt-5">
      {/* <p>Why Choose Us</p> */}
      <p class="fs-1 fw-semibold ">{data?.titleHeading?.text}</p>
      <p class="fs-1 fw-semibold line-height-1 mb-2 org">
        {data?.titleHeading?.highlight}
      </p>

      <div class="row mt-5">
        {data?.items?.map?.((el, index) => {
          let borderClass = "";
          // Apply right border for the first two columns in each row
          if (index % 3 === 0 || index % 3 === 1) {
            borderClass = "border-end";
          }

          return (
            <div
              key={index}
              className={`col-lg-4 col-md-6 col-11 text-start p-2 m-auto ${borderClass}`}
            >
              <div class="whyChoose p-3 h-100">
                <p class="fs-4 fw-semibold">{el?.title}</p>
                <p class="mt-2 fs-5">{el?.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WhyChose;
